import styled from 'styled-components';

export const Container = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ContentArea = styled.div`
  padding: 16px 12px 16px 12px;
  padding-top: 0;

  @media (min-width: 768px) {
    padding: 20px 16px 20px 16px;
  }

  @media (min-width: 1200px) {
    padding: 24px 20px 24px 20px;
  }
`;

export const ListaCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;

  @media (min-width: 768px) {
    gap: 18px;
    margin-top: 14px;
  }

  @media (min-width: 1200px) {
    gap: 20px;
    margin-top: 16px;
  }
`;
